// extracted by mini-css-extract-plugin
export var container = "_82-0";
export var error = "_82-9";
export var label = "_82-5";
export var light = "_82-6";
export var md = "_82-3";
export var sm = "_82-2";
export var thin = "_82-8";
export var thinBold = "_82-7";
export var vertical = "_82-4";
export var xs = "_82-1";